export default __webpack_public_path__ + "89aecbbd9839e0a1bd53712ee83318cf.jpg";